import EncodedChar from "sms-segments-calculator/dist/libs/EncodedChar";

/**
 * This is a method to test whether the majority of the text is RTL or LTR
 * characters.
 *
 * this should only be used when you don't explicitly know the text's direction
 *
 * @link https://stackoverflow.com/questions/12006095/javascript-how-to-check-if-character-is-rtl
 *
 * @param text a string
 * @returns wether the primary direction of string is RTL
 */
export function isTextRTL(text: string): boolean {
	let rtl_count = (
		text.match(/[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/g) || []
	).length;
	let ltr_count = (
		text.match(
			/[A-Za-z\u00C0-\u00C0\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF]/g
		) || []
	).length;

	return rtl_count > ltr_count;
}
/**
 * type guard used to check wether this part of the message is an encoded
 * character as supposed to a header or other information
 *
 *
 * @param char the object that could be an encoded character
 * @returns true when the object is an encoded character
 */
export function isEncodedChar(char: unknown): char is EncodedChar {
	const isObject = (obj: unknown): obj is Partial<EncodedChar> =>
		typeof obj === "object" && !!obj;
	return (
		isObject(char) &&
		"raw" in char &&
		typeof char.raw === "string" &&
		"codeUnits" in char &&
		Array.isArray(char.codeUnits) &&
		char.codeUnits.every((codeUnit) => typeof codeUnit === "number") &&
		"isGSM7" in char &&
		typeof char.isGSM7 === "boolean" &&
		"encoding" in char &&
		typeof char.encoding === "string"
	);
}
